<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.dataDesejadaInfraestruturas"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        fields: [
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(infraestrutura) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o local de atendimento?',
                async () => this.data.model.dataDesejadaInfraestruturas
                    .splice(this.data.model.dataDesejadaInfraestruturas.indexOf(infraestrutura), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>